import * as types from './types';

export const showEPG = () => ({ type: types.SHOW });

export const hideEPG = () => ({ type: types.HIDE });
